import { useLayoutEffect, useRef } from "react";

// Fill a window's starting values once per opening (and again only if the
// record being edited changes while it is open). Lists or other props that
// arrive or reload while the window is open never blank what was typed.
// Runs before the window is drawn, so it never shows the last opening's
// values and nothing typed can be overwritten. (ZEN-841)
export function useFillOnOpen(open, recordKey, fill) {
  const latest = useRef(fill);
  latest.current = fill;
  useLayoutEffect(() => {
    if (open) latest.current();
  }, [open, recordKey]);
}
